export const aciFreeInternationalCalls = {
    iconName: 'free-international-calls',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M17.709 19.812a9.436 9.436 0 003.053-3.334 9.378 9.378 0 00.12-8.757 9.432 9.432 0 00-2.962-3.414A9.515 9.515 0 009.194 3.14a9.47 9.47 0 00-3.763 2.515 9.402 9.402 0 00-2.155 3.968',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M14.722 2.844a13.463 13.463 0 011.843 5.424c.457 2.93.308 5.916-.432 8.78M21.892 11.357h-11.89M20.452 6.962H4.43M21.116 15.752h-4.67M10.16 2.844a12.516 12.516 0 00-1.684 4.445c-.093.485-.177.97-.236 1.456M11.036 20.863l.007.004a2.697 2.697 0 003.334-.533l.358-.395a.899.899 0 00-.062-1.27l-1.666-1.51a.898.898 0 00-1.27.063.9.9 0 01-1.27.062l-2.664-2.416a.9.9 0 01-.063-1.27v0a.9.9 0 00-.062-1.27l-1.665-1.51a.899.899 0 00-1.27.063l-.359.395a2.698 2.698 0 00-.203 3.37l.004.006a24.338 24.338 0 006.851 6.21v0z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
